import {ActionTypes, CCAxios} from './../../cc-imports'

const NotificationActions = {

    fetchNotifications: (userId, skip, limit, type) => {
        return {
            type: ActionTypes.GET_NOTIFICATIONS,
            payload: CCAxios.get('/notification/userId/' + userId + '/' + skip + '/' + limit + '/'),
            meta: {
                type: type,
                id: userId
            }
        }
    },

    getNtfnById: (req, type)=> {
        return {
            type: ActionTypes.GET_NOTIFICATION,
            payload: CCAxios.get('/notification/ntfnId/' + req.ntfnId + '/'),
            meta : {
                type : type
            }
        }
    },
    getUnseenCount: (req)=> {
        return {
            type: ActionTypes.GET_UNSEEN_COUNT,
            payload: CCAxios.get('/notification/unseen/userId/' + req.userId +'/')
        }
    },
    updateSeen: (req)=> {
        return {
            type: ActionTypes.UPDATE_SEEN,
            payload: CCAxios.get('/notification/seen/userId/' + req.userId + '/' + req.skip + '/' + req.limit + '/')
        }
    },
    ntfnUpdated: (ntfn, userId)=>{
        return {
            type: ActionTypes.NOTIFICATION_UPDATED,
            payload: ntfn,
        }
    }
};

export default NotificationActions



// WEBPACK FOOTER //
// ./src/app/data/actions/NotificationActions.js